import { graphql } from 'gatsby';
import pushInDataLayer from '@/utils/pushInDataLayer';

type DatalayerEventType = {
  event: string;
  [key: string]: unknown;
};

const useDatalayerEvent = (props?: Queries.DATALAYER_EVENTFragment | null) => {
  if (!props?.datalayerEventElements) {
    return { hasEvent: false, triggerEvent: () => void 0 };
  }

  const { name, data } = props.datalayerEventElements;
  const eventName = name.value;
  const dataLayerObject: DatalayerEventType = {
    event: eventName,
  };

  if (data?.value && data?.value?.length > 0) {
    const dataObjectKey = `${eventName}_data`;
    dataLayerObject[dataObjectKey] = {};
    data.value.forEach(({ datalayerEventItemElements }) => {
      (dataLayerObject[dataObjectKey] as DatalayerEventType)[datalayerEventItemElements.key.value] =
        datalayerEventItemElements.value.value;
    });
  }

  return {
    hasEvent: true,
    triggerEvent: () => {
      pushInDataLayer(dataLayerObject);
    },
  };
};

export const fragment = graphql`
  fragment DATALAYER_EVENT on kontent_item_datalayer_event {
    datalayerEventElements: elements {
      name {
        value
      }
      data {
        value {
          ... on kontent_item_datalayer_event_item {
            datalayerEventItemElements: elements {
              key {
                value
              }
              value {
                value
              }
            }
          }
        }
      }
    }
  }
`;

export default useDatalayerEvent;
